import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { BaseComponent, ProgressBarService, MRMValidators } from '@mrm/core';

@Component({
    selector: 'signature-recipient.component',
    templateUrl: './signature-recipient.component.html'
})

export class SignatureRecipientComponent extends BaseComponent implements OnInit {
    @Input() title: string = this._translateService.instant('Recipient');
    @Input() recipient: string = null;
    @Input() recipientMessage: string = null;

    recipientForm: FormGroup;

    constructor(
        private __progressBarService: ProgressBarService,
        private __toastr: ToastrService,
        private __translateService: TranslateService,
        public activeModal: NgbActiveModal,
        private _formBuilder: FormBuilder
    ) {
        super(__progressBarService, __toastr, __translateService);
    }

    ngOnInit(): void {
        // Set up form.
        this.recipientForm = this._formBuilder.group({
            recipient: new FormControl({ value: this.recipient, disabled: false }, [Validators.required, MRMValidators.multipleEmails])
        });
    }

    send(): void {
        if (this.recipientForm.valid) {
            this.activeModal.close(this.recipientForm.value.recipient);
        } else {
            this._toastr.error(this._translateService.instant('FillRequiredFields'));
        }
    }

    cancel(reason: string): void {
        this.activeModal.dismiss('');
    }
}